import React from "react";
import "./Mockup.css";

const Mockup = (props) => {
  return (
    <div className="mockupContainer">
      <div className="mock1">
        <p className="mock1Text">Mockup of a Fast Food / Restaurant site</p>
        <div className="mock1Img"></div>
      </div>
      <hr />
      <div className="mock2">
        <p className="mock2Text">
          Disney+ clone site built with a custom API & Authentication. The site
          was built in React and Firebase
        </p>
        <p className="disclaimer">
          Visit the site by clicking on the Image below!
        </p>

        <a
          className="mock2Img"
          rel="noreferrer noopener"
          href="https://disney-clone-3e496.web.app/"
          target="_blank"
        >
          Disney+ clone link
        </a>
      </div>
    </div>
  );
};

export default Mockup;
